import { initOutputDateRange } from "src/features/PageConfigProvider/constants/initOutputDateRange";
import { FilterFields, FilterFieldsKeys } from "../types/FilterFields";

export const initFields: FilterFields = {
  [FilterFieldsKeys.CreationTime]: initOutputDateRange,
  [FilterFieldsKeys.LastModifiedTime]: initOutputDateRange,
  [FilterFieldsKeys.AssetName]: "",
  [FilterFieldsKeys.SpenderAddress]: "",
  [FilterFieldsKeys.ChainName]: "",
  [FilterFieldsKeys.BatchId]: "",
  [FilterFieldsKeys.Statuses]: []
};
